if (document.readyState !== 'loading') 
{
    initN9AiUpsells();
} 
else 
{
    document.addEventListener('DOMContentLoaded', function () 
    {
        initN9AiUpsells();
    });
}

function initN9AiUpsells()
{
    if(!allow_AI_upsells)
    {
        console.log("%cAddly Product Upsells/Bundles %c:: %chttps://apps.shopify.com/addly :: %cTheme: %cOLD :: %cMethod: %cAI :: %cDiscounts: %c"+endDiscountType+"|"+endDiscountVal+" :: %cInfo: %cManual offers only!", GreenN9Info, WhiteN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info);
        return;
    }

    if(!n9_show_ai_products)
    {
        console.log("%cAddly Product Upsells/Bundles %c:: %chttps://apps.shopify.com/addly :: %cTheme: %cOLD :: %cMethod: %cAI :: %cDiscounts: %c"+endDiscountType+"|"+endDiscountVal+" :: %cInfo: %cFiltered", GreenN9Info, WhiteN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info);
        return;
    }

    const getRecommendationsN9 = async () => 
    {
        window.money_format = n9MoneyFormat;

        function moneyFormat(cents, format) 
        {
            if (typeof cents === 'string') 
            {
                cents = cents.replace('.', '');
            }
            let value = '';
            const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            var formatString = (format || window.money_format);
            if (!formatString) 
            {
                formatString = n9MoneyFormat;
            }

            function defaultOption(opt, def) 
            {
                return (typeof opt === 'undefined' ? def : opt);
            }

            function formatWithDelimiters(number, precision, thousands, decimal) 
            {
                precision = defaultOption(precision, 2);
                thousands = defaultOption(thousands, ',');
                decimal = defaultOption(decimal, '.');
                if (Number.isNaN(number) || number == null) 
                {
                    return 0;
                }
                number = (number / 100.0).toFixed(precision);
                const parts = number.split('.');
                const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
                cents = parts[1] ? (decimal + parts[1]) : '';
                return dollars + cents;
            }
            switch (formatString.match(placeholderRegex)[1]) 
            {
                case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
            }
            return formatString.replace(placeholderRegex, value);
        }
        const res = await fetch(window.Shopify.routes.root + "recommendations/products.json?product_id="+n9CurrentProductId+"&limit="+n9AiLimit+"&intent=related").then(response => response.json()).then(({ products }) => 
        {
            dataPromiseN9.then((result) => 
            {
                if(result.code)
                {
                    if (products.length > 0) 
                    {
                        var productsInThisBundle = '';
                        if(upsellAddMain) productsInThisBundle = n9CurrentProductId+',';

                        var maxProducts = products.length;
                        for (var n = 0; n < maxProducts; n++) 
                        {
                            var prod = products[n];
                            if (!prod.available) 
                            {
                                return;
                            }

                            productsInThisBundle = productsInThisBundle + prod.id + ",";
                        }
                        

                        //console.log(productsInThisBundle);

                        if(productsInThisBundle)
                        {
                            productsInThisBundle = productsInThisBundle.slice(0, -1); // removes last ,

                            // check if the current bundle products are in the current cart attribute configuration
                            var checkN9Obj = {products: productsInThisBundle, discountValue: 0, discountType: '0'};
                            var isFoundN9Obj = isObjectInArrayN9(checkN9Obj,n9_bundle_discounts);

                            if(isFoundN9Obj) // if found in cart attributes
                            {
                                //console.log("isFoundN9Obj [AI]: " + isFoundN9Obj);

                                if(endDiscountType > 0) // if we have discounts -> Update
                                {
                                    //console.log("We have discounts -> Update Configuration [AI]");

                                    var discountTypeDiscounts = '1';
                                    var discountValueDiscounts = endDiscountVal;
                                    if(endDiscountType == 1) // fixed
                                    {
                                        discountTypeDiscounts = '0';
                                        discountValueDiscounts = endDiscountVal;
                                    }
                                    else if(endDiscountType == 2) // %
                                    {
                                        discountTypeDiscounts = '1';
                                        discountValueDiscounts = endDiscountVal * 100;
                                    }

                                    var updateN9Obj = {products: productsInThisBundle, discountValue: discountValueDiscounts, discountType: discountTypeDiscounts};
                                    addN9BundleDiscountObject(updateN9Obj, n9_bundle_discounts);
                                }
                                else // we don't have discounts anymore --> Remove
                                {
                                    //console.log("We don't have discounts anymore --> Remove [AI]");

                                    var removeN9Obj = {products: productsInThisBundle, discountValue: 0, discountType: '0'};
                                    var removeN9DiscountStatus = removeN9BundleDiscountObject(removeN9Obj, n9_bundle_discounts);
                                }

                                var buildAttributeDiscounts = [];
                                buildAttributeDiscounts.push(['n9_bundle_discounts', JSON.stringify(n9_bundle_discounts)]);
                                buildAttribute = arr2obj_upd(buildAttributeDiscounts);
                                var headers = new Headers({'Content-Type': 'application/json'});
                                var bodyRequest = JSON.stringify({attributes: buildAttribute});
                                var request = {method: 'POST',headers: headers,body: bodyRequest};
                                fetch('/cart/update.js', request).then(function () { });
                            }
                            //else console.log("Obj discounts not found [AI]");
                        }
                    }

                    if(upsellLayout == 1)
                    {
                        if (products.length > 0) 
                        {
                            var productCount = products.length;
                            var maxProducts = products.length;
                            for (var n = 0; n < maxProducts; n++) 
                            {
                                var prod = products[n];
                                //console.log(prod);
                                if (!prod.available) 
                                {
                                    return;
                                }
                                var li = document.createElement("li");
                                li.className = "n9-fbt-product-item-layout2 n9-product-item-layout2";
                                var a1 = document.createElement("div");
                                a1.className = "n9-remove-href-styling n9-product-a-layout2";
                                a1.style = "cursor: pointer;";
                                a1.setAttribute("onClick", "n9_OpenProductQuickView(" + prod.id + ", '"+prod.handle+"')");
                                li.appendChild(a1);
                                var img1 = document.createElement("img");
                                img1.setAttribute("src", prod.images[0]);
                                img1.className = "n9-fbt-product-img img-fluid-n9 n9-product-img-layout2";
                                img1.style = "width: auto; height: 96px;";
                                a1.appendChild(img1);
                                var h3 = document.createElement("h3");
                                h3.className = "n9-fbt-product-title h6";
                                li.appendChild(h3);
                                var a2 = document.createElement("div");
                                a2.className = "n9-remove-href-styling n9-char-limiter";
                                a2.style = "cursor: pointer;";
                                a2.setAttribute("onClick", "n9_OpenProductQuickView(" + prod.id + ", '"+prod.handle+"')");
                                a2.innerHTML = prod.title;
                                h3.appendChild(a2);
                                var select = document.createElement("select");
                                select.setAttribute("id", "n9_variant_select_" + prod.id);
                                select.setAttribute("data-product-id", prod.id);
                                select.setAttribute("name", "id");
                                select.setAttribute("aria-label", "Select variant");
                                if (prod.variants.length < 2) 
                                {
                                    //select.style = "display: none;";
                                    select.className = "n9-fbt-variant-select n9-product-select-layout2 n9-product-select-1Variant";
                                }
                                else
                                {
                                    select.className = "n9-fbt-variant-select n9-product-select-layout2";
                                }
                                h3.appendChild(select);
                                var variantsPrice = [];
                                var variantsImage = [];
                                if (prod.variants.length > 0) 
                                {
                                    for (var v = 0; v < prod.variants.length; v++) 
                                    {
                                        var option_title = prod.variants[v].title;
                                        var option_price = (prod.variants[v].price);
                                        var option_comparedPrice = (prod.variants[v].compare_at_price);
                                        if (prod.variants[v].compare_at_price == null) {
                                            option_comparedPrice = 0;
                                        }
                                        var option_id = prod.variants[v].id;
                                        if (prod.variants[v].featured_image == null) {
                                            var option_image = prod.images[0];
                                        } else {
                                            var option_image = prod.variants[v].featured_image.src;
                                        }
                                        var option = document.createElement("option");
                                        option.value = option_id;
                                        option.setAttribute("data-image", option_image);
                                        option.setAttribute("data-compare-price", option_comparedPrice);
                                        option.setAttribute("data-price", option_price);
                                        if (prod.variants[v].available == false) 
                                        {
                                            option.setAttribute("disabled", "disabled");
                                            option.className = "n9-product-select-variant-disabled";
                                        }
                                        if(prod.variants.length > 1)
                                        {
                                            option.innerHTML = option_title;
                                        }
                                        else
                                        {
                                            option.innerHTML = '<span class="n9-product-variant-default-text">' + option_title + '</span>';
                                        }
                                        select.appendChild(option);
                                        if (prod.variants[v].available == true) 
                                        {
                                            variantsPrice.push(option_price);
                                            variantsImage.push(option_image);
                                        }
                                    }
                                }
                                var p = document.createElement("p");
                                p.className = "n9-fbt-product-price n9-product-price-layout2";
                                li.appendChild(p);
                                var span1 = document.createElement("span");
                                span1.className = "n9-fbt-product-price-compare";
                                if (prod.variants.length > 0) {
                                    span1.innerHTML = "<s>" + moneyFormat(prod.variants[0].compare_at_price) + "</s>";
                                    if (prod.variants[0].compare_at_price <= prod.variants[0].price) {
                                        span1.style = "display: none;";
                                    }
                                } else {
                                    span1.innerHTML = "<s>" + moneyFormat(prod.compare_at_price) + "</s>";
                                    if (prod.compare_at_price <= prod.price) {
                                        span1.style = "display: none;";
                                    }
                                }
                                p.appendChild(span1);
                                var span2 = document.createElement("span");
                                span2.className = "n9-fbt-product-price-final";
                                span2.innerHTML = moneyFormat(prod.price);
                                p.appendChild(span2);
                                var div1 = document.createElement("div");
                                div1.className = "n9-fbt-add-checkbox-wrapper";
                                div1.innerHTML = '<input id="n9-fbt-add-checkbox-' + prod.id + '" class="n9-fbt-add-checkbox" type="checkbox" checked> <label class="n9-fbt-add-checkbox-text" for="n9-fbt-add-checkbox-' + prod.id + '">' + n9_fbt_text_add_this + '</label>';
                                li.appendChild(div1);
                                if (prod.variants.length > 1) {
                                    if (variantsPrice.length > 0) {
                                        span2.innerHTML = moneyFormat(variantsPrice[0]);
                                    }
                                }
                                if (prod.variants.length > 1) {
                                    if (variantsImage.length > 0) {
                                        img1.setAttribute("src", variantsImage[0]);
                                    }
                                }
                                document.querySelector(".n9RecommendationsUl").appendChild(li);
                                if ((n + 1) < (productCount)) {
                                    var additional_li = document.createElement("li");
                                    additional_li.className = "n9_fbt_plus_li";
                                    additional_li.style = 'width:6px;font-size:13px;';
                                    additional_li.innerHTML = '<b class="n9_fbt_plus_li_b" style="color: #444444; height: 100%;display: flex;align-items: baseline; margin-top: 40px;">+</b>';
                                    document.querySelector(".n9RecommendationsUl").appendChild(additional_li);
                                }
                            }
                            document.querySelector("n9-fbt").style.display = "";
                            setTimeout(() => 
                            {
                                document.querySelector("n9-fbt").style.opacity = '1';
                            }, 100);

                            console.log("%cAddly Product Upsells/Bundles %c:: %chttps://apps.shopify.com/addly :: %cTheme: %cOLD :: %cMethod: %cAI :: %cDiscounts: %c"+endDiscountType+"|"+endDiscountVal+" :: %cInfo: %c"+products.length+" products found from AI", GreenN9Info, WhiteN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info);
                        } 
                        else 
                        {
                            console.log("%cAddly Product Upsells/Bundles %c:: %chttps://apps.shopify.com/addly :: %cTheme: %cOLD :: %cMethod: %cAI :: %cDiscounts: %c"+endDiscountType+"|"+endDiscountVal+" :: %cInfo: %cNot enough data from AI", GreenN9Info, WhiteN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info);
                            //console.log("N9 AI Recommendations: Hidden, because there are no products to show");
                            if (Shopify.designMode || Shopify.inspectMode) 
                            {
                                //console.log("N9 Backup: Loading Preview for the current Layout!");
                                var maxProducts = n9_fbt_product_preview;
                                for (var n = 0; n < maxProducts; n++) 
                                {
                                    var li = document.createElement("li");
                                    li.className = "n9-fbt-product-item-layout2 n9-product-item-layout2";
                                    var a1 = document.createElement("div");
                                    a1.className = "n9-remove-href-styling n9-product-a-layout2";
                                    a1.style = "cursor: pointer;";
                                    li.appendChild(a1);
                                    var img1 = document.createElement("img");
                                    img1.setAttribute("src", n9CurrentProductImage);
                                    img1.className = "n9-fbt-product-img img-fluid-n9 n9-product-img-layout2";
                                    img1.style = "width: auto; height: 96px;";
                                    a1.appendChild(img1);
                                    var h3 = document.createElement("h3");
                                    h3.className = "n9-fbt-product-title h6";
                                    li.appendChild(h3);
                                    var a2 = document.createElement("div");
                                    a2.className = "n9-remove-href-styling n9-char-limiter";
                                    a2.style = "cursor: pointer;";
                                    a2.innerHTML = "Upsell Product Title Placeholder";
                                    h3.appendChild(a2);
                                    var select = document.createElement("select");
                                    select.className = "n9-fbt-variant-select2 n9-product-select-layout2";
                                    select.style = "width: 100%; padding: 0.25rem;";
                                    h3.appendChild(select);
                                    var option_title = "Variant 1";
                                    var option = document.createElement("option");
                                    option.innerHTML = option_title;
                                    select.appendChild(option);
                                    var p = document.createElement("p");
                                    p.className = "n9-fbt-product-price n9-product-price-layout2";
                                    li.appendChild(p);
                                    var span1 = document.createElement("span");
                                    span1.className = "n9-fbt-product-price-compare";
                                    span1.style = "display: none;";
                                    span1.innerHTML = "<s>" + moneyFormat(0) + "</s>";
                                    p.appendChild(span1);
                                    var span2 = document.createElement("span");
                                    span2.className = "n9-fbt-product-price-final";
                                    span2.innerHTML = moneyFormat(0);
                                    p.appendChild(span2);
                                    var div1 = document.createElement("div");
                                    div1.className = "n9-fbt-add-checkbox-wrapper";
                                    div1.innerHTML = '<input id="n9-fbt-add-checkbox-'+ n9CurrentProductId + n + '" class="n9-fbt-add-checkbox" type="checkbox" checked> <label class="n9-fbt-add-checkbox-text" for="n9-fbt-add-checkbox-'+ n9CurrentProductId + n + '">' + n9_fbt_text_add_this + '</label>';
                                    li.appendChild(div1);
                                    document.querySelector(".n9RecommendationsUl").appendChild(li);
                                    if (n == 0) {
                                        var additional_li = document.createElement("li");
                                        additional_li.className = "n9_fbt_plus_li";
                                        additional_li.style = 'width:6px;font-size:13px;';
                                        additional_li.innerHTML = '<b class="n9_fbt_plus_li_b" style="color: #444444; height: 100%;display: flex;align-items: baseline; margin-top: 40px;">+</b>';
                                        document.querySelector(".n9RecommendationsUl").appendChild(additional_li);
                                    }
                                }
                                document.querySelector(".n9-fbt-heading-title").innerHTML = "<u>Example</u> Upsell<br><small style='display: initial;font-size: 12px; color: red;'>Visible only for you in Admin Mode<br>You can change the settings from the app - Addly</small>";
                                document.querySelector("n9-fbt").style.display = "";
                                setTimeout(() => 
                                {
                                    document.querySelector("n9-fbt").style.opacity = '1';
                                }, 100);
                            }
                        }
                    }
                    else if(upsellLayout == 2 || upsellLayout == 4 || upsellLayout == 5)
                    {
                        if (products.length > 0) 
                        {
                            var maxProducts = products.length;
                            for (var n = 0; n < maxProducts; n++) 
                            {
                                var prod = products[n];
                                if (!prod.available) 
                                {
                                    return;
                                }
                                var li = document.createElement("li");
                                li.className = "n9-fbt-product-item-layout3 n9-product-item-layout3";
                                li.style = "border:2px solid "+n9_fbt_borders_color+";";
                                var a1 = document.createElement("div");
                                a1.className = "removehrefStyling";
                                a1.style = "cursor: pointer;";
                                li.appendChild(a1);
                                var span1 = document.createElement("span");
                                span1.className = "n9-product-img-block-layout3";
                                span1.setAttribute("onClick", "n9_OpenProductQuickView(" + prod.id + ", '"+prod.handle+"')");
                                var img1 = document.createElement("img");
                                img1.setAttribute("src", prod.images[0]);
                                img1.className = "n9-fbt-product-img n9-product-img-layout3";
                                img1.style = "width: auto; height: 96px;";
                                span1.appendChild(img1);
                                a1.appendChild(span1);
                                var h3 = document.createElement("h3");
                                h3.className = "n9-fbt-product-title h6 n9-product-title-layout3";
                                h3.style = "width: 100%;";
                                a1.appendChild(h3);
                                var a2 = document.createElement("div");
                                a2.className = "removehrefStyling titleCharLimit";
                                a2.style = "cursor: pointer; width: 70%; margin-left: 15%;";
                                a2.setAttribute("onClick", "n9_OpenProductQuickView(" + prod.id + ", '"+prod.handle+"')");
                                a2.innerHTML = prod.title;
                                h3.appendChild(a2);
                                var select = document.createElement("select");
                                select.setAttribute("id", "n9_variant_select_" + prod.id);
                                select.setAttribute("data-product-id", prod.id);
                                select.setAttribute("name", "id");
                                select.setAttribute("aria-label", "Select variant");
                                if (prod.variants.length < 2) 
                                {
                                    select.style = "margin-left: 25%;"; // display: none;
                                    select.className = "n9-fbt-variant-select n9-product-select-layout3 n9-product-select-1Variant";
                                } 
                                else 
                                {
                                    select.style = "margin-left: 25%;";
                                    select.className = "n9-fbt-variant-select n9-product-select-layout3";
                                }
                                h3.appendChild(select);
                                var variantsPrice = [];
                                var variantsImage = [];
                                if (prod.variants.length > 0) 
                                {
                                    for (var v = 0; v < prod.variants.length; v++) 
                                    {
                                        var option_title = prod.variants[v].title;
                                        var option_price = (prod.variants[v].price);
                                        var option_comparedPrice = (prod.variants[v].compare_at_price);
                                        if (prod.variants[v].compare_at_price == null) 
                                        {
                                            option_comparedPrice = 0;
                                        }
                                        var option_id = prod.variants[v].id;
                                        if (prod.variants[v].featured_image == null) 
                                        {
                                            var option_image = prod.images[0];
                                        } 
                                        else 
                                        {
                                            var option_image = prod.variants[v].featured_image.src;
                                        }
                                        var option = document.createElement("option");
                                        option.value = option_id;
                                        option.setAttribute("data-image", option_image);
                                        option.setAttribute("data-compare-price", option_comparedPrice);
                                        option.setAttribute("data-price", option_price);
                                        if (prod.variants[v].available == false) 
                                        {
                                            option.setAttribute("disabled", "disabled");
                                            option.className = "n9-product-select-variant-disabled";
                                        }
                                        if(prod.variants.length > 1)
                                        {
                                            option.innerHTML = option_title;
                                        }
                                        else
                                        {
                                            option.innerHTML = '<span class="n9-product-variant-default-text">' + option_title + '</span>';
                                        }
                                        select.appendChild(option);
                                        if (prod.variants[v].available == true) 
                                        {
                                            variantsPrice.push(option_price);
                                            variantsImage.push(option_image);
                                        }
                                    }
                                }
                                var div1 = document.createElement("div");
                                div1.className = "n9-pricing-holder-individual";
                                div1.style = "display: block;";
                                a1.appendChild(div1);
                                var span1 = document.createElement("span");
                                span1.className = "n9-fbt-product-price-final";
                                span1.innerHTML = moneyFormat(prod.price);
                                div1.appendChild(span1);
                                var span2 = document.createElement("span");
                                span2.className = "n9-fbt-product-price-compare";
                                if (prod.variants.length > 0) {
                                    span2.innerHTML = '<sup><s>' + moneyFormat(prod.variants[0].compare_at_price) + '</s></sup>';
                                    if (prod.variants[0].compare_at_price <= prod.variants[0].price) {
                                        span2.style = "display: none;";
                                    }
                                } else {
                                    span2.innerHTML = '<sup><s>' + moneyFormat(prod.compare_at_price) + '</s></sup>';
                                    if (prod.compare_at_price <= prod.price) {
                                        span2.style = "display: none;";
                                    }
                                }
                                div1.appendChild(span2);
                                var div2 = document.createElement("div");
                                div2.className = "n9-fbt-add-checkbox-wrapper n9-product-checkbox-layout3";
                                div2.style = "display: none;";
                                div2.innerHTML = '<input id="n9-fbt-add-checkbox-' + prod.id + '" class="n9-fbt-add-checkbox" type="checkbox" checked><label class="n9-fbt-add-checkbox-text" for="n9-fbt-add-checkbox-' + prod.id + '">' + n9_fbt_text_add_this + '</label>';
                                a1.appendChild(div2);
                                var button1 = document.createElement("button");
                                var btnStyling = 'display: block;';
                                if(products.length == 1 && upsellAddMain == 0) btnStyling = 'display: none;';
                                button1.style = "width: "+upsellsWidgetButtons1+";"+btnStyling+"margin: 0 auto;padding-left: 20px;padding-right: 20px;";
                                button1.className = "n9-fbt-btn-custom addly_solo_addToCart n9-product-button-layout3";
                                button1.setAttribute("data-product-id", prod.id);
                                button1.setAttribute("id", "n9_product_btn_" + prod.id);
                                button1.type = "button";
                                button1.setAttribute("data-text-add-selected", n9_fbt_text_add_to_cart);
                                button1.innerHTML = n9_fbt_text_add_to_cart;
                                a1.appendChild(button1);
                                if (prod.variants.length > 0) {
                                    if (variantsPrice.length > 0) {
                                        span1.innerHTML = moneyFormat(variantsPrice[0]);
                                    }
                                }
                                if (prod.variants.length > 0) {
                                    if (variantsImage.length > 0) {
                                        img1.setAttribute("src", variantsImage[0]);
                                    }
                                }
                                document.querySelector(".n9RecommendationsUl").appendChild(li);
                                var line_connector = document.createElement("div");
                                line_connector.className = "n9-ver-line-connector n9-product-connector-layout3";
                                line_connector.style = "border-right:2px dashed "+n9_fbt_borders_color+";";
                                line_connector.innerHTML = "<div></div>";
                                document.querySelector(".n9RecommendationsUl").appendChild(line_connector);
                            }
                            document.querySelector("n9-fbt").style.display = "";
                            setTimeout(() => 
                            {
                                document.querySelector("n9-fbt").style.opacity = '1';
                            }, 100);
                            console.log("%cAddly Product Upsells/Bundles %c:: %chttps://apps.shopify.com/addly :: %cTheme: %cOLD :: %cMethod: %cAI :: %cDiscounts: %c"+endDiscountType+"|"+endDiscountVal+" :: %cInfo: %c"+products.length+" products found from AI", GreenN9Info, WhiteN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info);
                        } 
                        else 
                        {
                            console.log("%cAddly Product Upsells/Bundles %c:: %chttps://apps.shopify.com/addly :: %cTheme: %cOLD :: %cMethod: %cAI :: %cDiscounts: %c"+endDiscountType+"|"+endDiscountVal+" :: %cInfo: %cNot enough data from AI", GreenN9Info, WhiteN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info);
                            //console.log("N9 AI Recommendations: Hidden, because there are no products to show");
                            if (Shopify.designMode || Shopify.inspectMode) 
                            {
                                //console.log("N9 Backup: Loading Preview for the current Layout!");
                                var maxProducts = n9_fbt_product_preview;
                                for (var n = 0; n < maxProducts; n++) 
                                {
                                    var li = document.createElement("li");
                                    li.className = "n9-fbt-product-item-layout3 n9-product-item-layout3";
                                    li.style = "border:2px solid "+n9_fbt_borders_color+";";
                                    var a1 = document.createElement("div");
                                    a1.className = "removehrefStyling";
                                    a1.style = "cursor: pointer;";
                                    li.appendChild(a1);
                                    var span1 = document.createElement("span");
                                    span1.className = "n9-product-img-block-layout3";
                                    var img1 = document.createElement("img");
                                    img1.setAttribute("src", n9CurrentProductImage);
                                    img1.className = "n9-fbt-product-img n9-product-img-layout3";
                                    img1.style = "width: auto; height: 96px;";
                                    span1.appendChild(img1);
                                    a1.appendChild(span1);
                                    var h3 = document.createElement("h3");
                                    h3.className = "n9-fbt-product-title h6 n9-product-title-layout3";
                                    h3.style = "width: 100%;";
                                    a1.appendChild(h3);
                                    var a2 = document.createElement("div");
                                    a2.className = "removehrefStyling titleCharLimit";
                                    a2.style = "cursor: pointer; width: 70%; margin-left: 15%;";
                                    a2.innerHTML = "Upsell Product Title Placeholder";
                                    h3.appendChild(a2);
                                    var select = document.createElement("select");
                                    select.className = "n9-fbt-variant-select2 n9-product-select-layout3";
                                    select.style = "width: 100%; padding: 0.25rem;";
                                    h3.appendChild(select);
                                    var option_title = "Variant 1";
                                    var option = document.createElement("option");
                                    option.innerHTML = option_title;
                                    select.appendChild(option);
                                    var div1 = document.createElement("div");
                                    div1.className = "n9-pricing-holder-individual";
                                    div1.style = "display: block;";
                                    a1.appendChild(div1);
                                    var span1 = document.createElement("span");
                                    span1.className = "n9-fbt-product-price-final";
                                    span1.innerHTML = moneyFormat(0);
                                    div1.appendChild(span1);
                                    var span2 = document.createElement("span");
                                    span2.className = "n9-fbt-product-price-compare";
                                    span2.style = "display: none;";
                                    span2.innerHTML = '<sup><s>' + moneyFormat(0) + '</s></sup>';
                                    div1.appendChild(span2);
                                    var div2 = document.createElement("div");
                                    div2.className = "n9-fbt-add-checkbox-wrapper n9-product-checkbox-layout3";
                                    div2.style = "display: none;";
                                    div2.innerHTML = '<input id="n9-fbt-add-checkbox-'+ n9CurrentProductId + n + '" class="n9-fbt-add-checkbox" type="checkbox" checked><label class="n9-fbt-add-checkbox-text" for="n9-fbt-add-checkbox-'+n9CurrentProductId + n + '">' + n9_fbt_text_add_this + '</label>';
                                    a1.appendChild(div2);
                                    var button1 = document.createElement("button");
                                    button1.style = "width: "+upsellsWidgetButtons1+";display: block;margin: 0 auto;padding-left: 20px;padding-right: 20px;";
                                    button1.className = "n9-fbt-btn-custom n9-product-button-layout3";
                                    button1.setAttribute("data-product-id", n9CurrentProductId);
                                    button1.setAttribute("id", "n9_product_btn_"+n9CurrentProductId);
                                    button1.type = "button";
                                    button1.setAttribute("data-text-add-selected", n9_fbt_text_add_to_cart);
                                    button1.innerHTML = n9_fbt_text_add_to_cart;
                                    a1.appendChild(button1);
                                    document.querySelector(".n9RecommendationsUl").appendChild(li);
                                    var line_connector = document.createElement("div");
                                    line_connector.className = "n9-ver-line-connector n9-product-connector-layout3";
                                    line_connector.style = "border-right:2px dashed "+n9_fbt_borders_color+";";
                                    line_connector.innerHTML = "<div></div>";
                                    document.querySelector(".n9RecommendationsUl").appendChild(line_connector);
                                }
                                document.querySelector(".n9-fbt-heading-title").innerHTML = "<u>Example</u> Upsell<br><small style='display: initial;font-size: 12px; color: red;'>Visible only for you in Admin Mode<br>You can change the settings from the app - Addly</small>";
                                document.querySelector("n9-fbt").style.display = "";
                                setTimeout(() => 
                                {
                                    document.querySelector("n9-fbt").style.opacity = '1';
                                }, 100);
                            }
                        }
                    }
                    else if(upsellLayout == 3 || upsellLayout == 6)
                    {
                        if (products.length > 0) 
                        {
                            var elementBorder = n9_fbt_borders_color;
                            var maxProducts = products.length;
                            for (var n = 0; n < maxProducts; n++) 
                            {
                                var prod = products[n];
                                if (!prod.available) 
                                {
                                    return;
                                }
                                var li = document.createElement("li");
                                li.className = "n9-fbt-product-item-layout4 n9-product-item-layout4 splide__slide";
                                li.setAttribute("data-splide-interval", "4000");
                                li.style = "border-left:6px solid " + elementBorder + ";";
                                var div1 = document.createElement("div");
                                div1.style = "display: flex; width: 100%; height: 100%;";
                                li.appendChild(div1);
                                var div2 = document.createElement("div");
                                div2.style = "display: flex;align-items: center;width: fit-content;";
                                div1.appendChild(div2);
                                var a1 = document.createElement("div");
                                a1.className = "removehrefStyling";
                                a1.setAttribute("onClick", "n9_OpenProductQuickView(" + prod.id + ", '"+prod.handle+"')");
                                a1.style = "cursor: pointer;";
                                div2.appendChild(a1);
                                var img1 = document.createElement("img");
                                img1.setAttribute("src", prod.images[0]);
                                img1.className = "n9-fbt-product-img img-fluid-n9 n9-product-img-layout4";
                                img1.style = "width: 100px; height: 100px;";
                                a1.appendChild(img1);
                                var div3 = document.createElement("div");
                                div3.style = "width: 100%;";
                                div1.appendChild(div3);
                                var h3 = document.createElement("h3");
                                h3.className = "n9-fbt-product-title h6 n9-product-title-layout4";
                                h3.style = "height: 100%;";
                                div3.appendChild(h3);
                                var div4 = document.createElement("div");
                                div4.style = "height: 100%;display: flex;align-items: center;";
                                h3.appendChild(div4);
                                var div5 = document.createElement("div");
                                div4.appendChild(div5);
                                var a2 = document.createElement("div");
                                a2.className = "removehrefStyling titleCharLimit";
                                a2.setAttribute("onClick", "n9_OpenProductQuickView(" + prod.id + ", '"+prod.handle+"')");
                                a2.style = "cursor: pointer;";
                                a2.innerHTML = prod.title;
                                div5.appendChild(a2);
                                var select = document.createElement("select");
                                select.setAttribute("id", "n9_variant_select_" + prod.id);
                                select.setAttribute("data-product-id", prod.id);
                                select.setAttribute("name", "id");
                                select.setAttribute("aria-label", "Select variant");
                                if (prod.variants.length < 2) 
                                {
                                    //select.style = "display: none;";
                                    select.className = "n9-fbt-variant-select n9-product-select-layout4 n9-product-select-1Variant";
                                }
                                else
                                {
                                    select.className = "n9-fbt-variant-select n9-product-select-layout4";
                                }
                                div5.appendChild(select);
                                var variantsPrice = [];
                                var variantsImage = [];
                                if (prod.variants.length > 0) 
                                {
                                    for (var v = 0; v < prod.variants.length; v++) 
                                    {
                                        var option_title = prod.variants[v].title;
                                        var option_price = (prod.variants[v].price);
                                        var option_comparedPrice = (prod.variants[v].compare_at_price);
                                        if (prod.variants[v].compare_at_price == null) 
                                        {
                                            option_comparedPrice = 0;
                                        }
                                        var option_id = prod.variants[v].id;
                                        if (prod.variants[v].featured_image == null) 
                                        {
                                            var option_image = prod.images[0];
                                        } 
                                        else 
                                        {
                                            var option_image = prod.variants[v].featured_image.src;
                                        }
                                        var option = document.createElement("option");
                                        option.value = option_id;
                                        option.setAttribute("data-image", option_image);
                                        option.setAttribute("data-compare-price", option_comparedPrice);
                                        option.setAttribute("data-price", option_price);
                                        if (prod.variants[v].available == false) 
                                        {
                                            option.setAttribute("disabled", "disabled");
                                            option.className = "n9-product-select-variant-disabled";
                                        }
                                        if(prod.variants.length > 1)
                                        {
                                            option.innerHTML = option_title;
                                        }
                                        else
                                        {
                                            option.innerHTML = '<span class="n9-product-variant-default-text">' + option_title + '</span>';
                                        }
                                        select.appendChild(option);
                                        if (prod.variants[v].available == true) 
                                        {
                                            variantsPrice.push(option_price);
                                            variantsImage.push(option_image);
                                        }
                                    }
                                }
                                var p = document.createElement("p");
                                p.className = "n9-fbt-product-price n9-product-price-layout4";
                                div5.appendChild(p);
                                var div6 = document.createElement("div");
                                div6.className = "n9-product-btnDiv-layout4";
                                div5.appendChild(div6);
                                var div7 = document.createElement("div");
                                div7.className = "n9-product-btnDiv2-layout4";
                                div6.appendChild(div7);
                                var button = document.createElement("button");
                                button.style = "width: "+upsellsWidgetButtons1+";display: block;margin: 0 auto;padding-left: 20px;padding-right: 20px;";
                                button.setAttribute("data-product-id", prod.id);
                                button.setAttribute("id", "n9_product_btn_" + prod.id);
                                button.className = "n9-fbt-btn-custom addly_slider_addToCart";
                                button.type = "button";
                                button.setAttribute("data-text-add-selected", n9_fbt_text_add_to_cart);
                                button.innerHTML = n9_fbt_text_add_to_cart;
                                div7.appendChild(button);
                                var span1 = document.createElement("span");
                                span1.className = "n9-fbt-product-price-compare";
                                if (prod.variants.length > 0) {
                                    span1.innerHTML = "<s>" + moneyFormat(prod.variants[0].compare_at_price) + "</s>";
                                    if (prod.variants[0].compare_at_price <= prod.variants[0].price) {
                                        span1.style = "display: none;";
                                    }
                                } else {
                                    span1.innerHTML = "<s>" + moneyFormat(prod.compare_at_price) + "</s>";
                                    if (prod.compare_at_price <= prod.price) {
                                        span1.style = "display: none;";
                                    }
                                }
                                p.appendChild(span1);
                                var span2 = document.createElement("span");
                                span2.className = "n9-fbt-product-price-final /*visually-hidden*/";
                                span2.innerHTML = moneyFormat(prod.price);
                                p.appendChild(span2);
                                var div8 = document.createElement("div");
                                div8.className = "n9-fbt-add-checkbox-wrapper";
                                div8.style = "display: none;";
                                div8.innerHTML = '<input id="n9-fbt-add-checkbox-' + prod.id + '" class="n9-fbt-add-checkbox" type="checkbox" checked><label class=n9-fbt-add-checkbox-text" for="n9-fbt-add-checkbox-' + prod.id + '">' + n9_fbt_text_add_this + '</label>';
                                div3.appendChild(div8);
                                if (prod.variants.length > 0) {
                                    if (variantsPrice.length > 0) {
                                        span2.innerHTML = moneyFormat(variantsPrice[0]);
                                        button.innerHTML = n9_fbt_text_add_to_cart;
                                    }
                                }
                                if (prod.variants.length > 0) {
                                    if (variantsImage.length > 0) {
                                        img1.setAttribute("src", variantsImage[0]);
                                    }
                                }
                                document.querySelector(".n9RecommendationsUl").appendChild(li);
                                if(upsellLayout == 6)
                                {
                                    if (products.length == 1)
                                    {
                                        document.querySelector(".n9RecommendationsUl").style.justifyContent = "center";
                                    }
                                }
                            }
                            document.querySelector("n9-fbt").style.display = "";
                            setTimeout(() => 
                            {
                                document.querySelector("n9-fbt").style.opacity = '1';
                            }, 100);
                            console.log("%cAddly Product Upsells/Bundles %c:: %chttps://apps.shopify.com/addly :: %cTheme: %cOLD :: %cMethod: %cAI :: %cDiscounts: %c"+endDiscountType+"|"+endDiscountVal+" :: %cInfo: %c"+products.length+" products found from AI", GreenN9Info, WhiteN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info);
                        } 
                        else 
                        {
                            console.log("%cAddly Product Upsells/Bundles %c:: %chttps://apps.shopify.com/addly :: %cTheme: %cOLD :: %cMethod: %cAI :: %cDiscounts: %c"+endDiscountType+"|"+endDiscountVal+" :: %cInfo: %cNot enough data from AI", GreenN9Info, WhiteN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info, GreenN9Info, WhiteN9Info);
                            //console.log("N9 AI Recommendations: Hidden, because there are no products to show");
                            if (Shopify.designMode || Shopify.inspectMode) 
                            {
                                //console.log("N9 Backup: Loading Preview for the current Layout!");
                                var elementBorder = n9_fbt_borders_color;
                                var maxProducts = n9_fbt_product_preview;
                                for (var n = 0; n < maxProducts; n++) 
                                {
                                    var li = document.createElement("li");
                                    li.className = "n9-fbt-product-item-layout4 n9-product-item-layout4 splide__slide";
                                    li.setAttribute("data-splide-interval", "4000");
                                    li.style = "border-left:6px solid " + elementBorder + ";";
                                    var div1 = document.createElement("div");
                                    div1.style = "display: flex; width: 100%; height: 100%;";
                                    li.appendChild(div1);
                                    var div2 = document.createElement("div");
                                    div2.style = "display: flex;align-items: center;width: fit-content;";
                                    div1.appendChild(div2);
                                    var a1 = document.createElement("div");
                                    a1.className = "removehrefStyling";
                                    a1.style = "cursor: pointer;";
                                    div2.appendChild(a1);
                                    var img1 = document.createElement("img");
                                    img1.setAttribute("src", n9CurrentProductImage);
                                    img1.className = "n9-fbt-product-img img-fluid-n9 n9-product-img-layout4";
                                    img1.style = "width: 100px; height: 100px;";
                                    a1.appendChild(img1);
                                    var div3 = document.createElement("div");
                                    div3.style = "width: 100%;";
                                    div1.appendChild(div3);
                                    var h3 = document.createElement("h3");
                                    h3.className = "n9-fbt-product-title h6 n9-product-title-layout4";
                                    h3.style = "height: 100%;";
                                    div3.appendChild(h3);
                                    var div4 = document.createElement("div");
                                    div4.style = "height: 100%;display: flex;align-items: center;";
                                    h3.appendChild(div4);
                                    var div5 = document.createElement("div");
                                    div4.appendChild(div5);
                                    var a2 = document.createElement("div");
                                    a2.className = "removehrefStyling titleCharLimit";
                                    a2.style = "cursor: pointer;";
                                    a2.innerHTML = "Upsell Product Title Placeholder";
                                    div5.appendChild(a2);
                                    var select = document.createElement("select");
                                    select.className = "n9-fbt-variant-select n9-product-select-layout4";
                                    div5.appendChild(select);
                                    var option_title = "Variant 1";
                                    var option = document.createElement("option");
                                    option.innerHTML = option_title;
                                    select.appendChild(option);
                                    var p = document.createElement("p");
                                    p.className = "n9-fbt-product-price n9-product-price-layout4";
                                    div5.appendChild(p);
                                    var div6 = document.createElement("div");
                                    div6.className = "n9-product-btnDiv-layout4";
                                    div5.appendChild(div6);
                                    var div7 = document.createElement("div");
                                    div7.className = "n9-product-btnDiv2-layout4";
                                    div6.appendChild(div7);
                                    var button = document.createElement("button");
                                    button.style = "width: "+upsellsWidgetButtons1+";display: block;margin: 0 auto;padding-left: 20px;padding-right: 20px;";
                                    button.setAttribute("data-product-id", n9CurrentProductId);
                                    button.setAttribute("id", "n9_product_btn_"+n9CurrentProductId);
                                    button.className = "n9-fbt-btn-custom";
                                    button.type = "button";
                                    button.setAttribute("data-text-add-selected", n9_fbt_text_add_to_cart);
                                    button.innerHTML = n9_fbt_text_add_to_cart;
                                    div7.appendChild(button);
                                    var span1 = document.createElement("span");
                                    span1.className = "n9-fbt-product-price-compare";
                                    span1.style = "display: none;";
                                    span1.innerHTML = "<s>" + moneyFormat(0) + "</s>";
                                    p.appendChild(span1);
                                    var span2 = document.createElement("span");
                                    span2.className = "n9-fbt-product-price-final";
                                    span2.innerHTML = moneyFormat(0);
                                    p.appendChild(span2);
                                    var div8 = document.createElement("div");
                                    div8.className = "n9-fbt-add-checkbox-wrapper";
                                    div8.style = "display: none;";
                                    div8.innerHTML = '<input id="n9-fbt-add-checkbox-'+n9CurrentProductId + n + '" class="n9-fbt-add-checkbox" type="checkbox" checked><label class="n9-fbt-add-checkbox-text" for="n9-fbt-add-checkbox-'+n9CurrentProductId + n + '">' + n9_fbt_text_add_this + '</label>';
                                    div3.appendChild(div8);
                                    document.querySelector(".n9RecommendationsUl").appendChild(li);
                                }
                                document.querySelector(".n9-fbt-heading-title").innerHTML = "<u>Example</u> Upsell<br><small style='display: initial;font-size: 12px; color: red;'>Visible only for you in Admin Mode<br>You can change the settings from the app - Addly</small>";
                                document.querySelector("n9-fbt").style.display = "";
                                setTimeout(() => 
                                {
                                    document.querySelector("n9-fbt").style.opacity = '1';
                                }, 100);
                            }
                        } 
                    }

                    if(n9_fbt_quickViewOption == 1)
                    {
                        if (products.length > 0) {
                            var arrayOfPopups = [];
                            var maxProducts = products.length;
                            for (var n = 0; n < maxProducts; n++) {
                                var prod = products[n];
                                if (!prod.available) {
                                    return;
                                }
                                arrayOfPopups.push(prod.id);
                                var mainDiv = document.createElement("div");
                                mainDiv.className = "modalUpsellProducts";
                                mainDiv.setAttribute("id", "N9QuickViewProduct_" + prod.id);
                                mainDiv.style = "display: none; opacity: 0;";
                                var div1 = document.createElement("div");
                                div1.className = "modalUpsellProducts n9-animation-zoom-in";
                                div1.setAttribute("id", "N9QuickViewProduct_" + prod.id + "_2");
                                div1.style = "display: none; background: transparent;";
                                mainDiv.appendChild(div1);
                                var div2 = document.createElement("div");
                                div2.className = "N9ProductUpsellsModal_QuickView";
                                div2.setAttribute("id", "N9QuickView_" + prod.id);
                                div2.style = "background: "+n9_fbt_background_color+";color: "+n9_fbt_text_color+";";
                                div1.appendChild(div2);
                                var span1 = document.createElement("span");
                                span1.setAttribute("id", "closeN9QuickView");
                                span1.className = "closeN9QuickView";
                                span1.setAttribute("onclick", "n9_CloseProductQuickView(" + prod.id + ")");
                                span1.innerHTML = "×";
                                div2.appendChild(span1);
                                var div3 = document.createElement("div");
                                div3.className = "N9ProductUpsellsModalBody_QuickView";
                                div2.appendChild(div3);
                                var div4 = document.createElement("div");
                                div4.className = "n9Upsells-Product-Container";
                                div3.appendChild(div4);
                                var div5 = document.createElement("div");
                                div5.className = "n9Upsells-Product-Block";
                                div5.setAttribute("id", "n9-quickview-product-block_" + prod.id);
                                div5.style = "display: flex; align-items: center; justify-content: center;";
                                div4.appendChild(div5);
                                var img1 = document.createElement("img");
                                img1.setAttribute("src", prod.images[0]);
                                img1.className = "n9-quickview-product-img";
                                img1.style = "max-width: 360px; height: auto; display: flex; padding: 2px 2px;";
                                div5.appendChild(img1);
                                var div6 = document.createElement("div");
                                div6.className = "n9Upsells-Product-Block n9Upsells-Product-Block-Info";
                                div6.innerHTML = "<h3>" + prod.title + "</h3><p>" + prod.description + "</p>";
                                div4.appendChild(div6);
                                var div7 = document.createElement("div");
                                div7.className = "N9ProductUpsellsModalFooter";
                                div7.style = "border-top: 1px solid "+n9_fbt_borders_color+";";
                                div2.appendChild(div7);
                                var div8 = document.createElement("div");
                                div8.className = "n9Upsells-Product-FooterBox";
                                div7.appendChild(div8);
                                var div9 = document.createElement("div");
                                div9.style = "align-items: center;display: flex;";
                                div8.appendChild(div9);
                                var select = document.createElement("select");
                                select.setAttribute("id", "n9_quickview_variant_select_" + prod.id);
                                select.setAttribute("data-product-id", prod.id);
                                select.className = "n9-quickview-variant-select";
                                select.setAttribute("name", "id");
                                select.setAttribute("aria-label", "Select variant");
                                if (prod.variants.length < 2) {
                                    select.style = "display: none;";
                                }
                                div9.appendChild(select);
                                var variantsPrice = [];
                                var variantsImage = [];
                                if (prod.variants.length > 0) {
                                    for (var v = 0; v < prod.variants.length; v++) {
                                        var option_title = prod.variants[v].title;
                                        var option_price = (prod.variants[v].price);
                                        var option_comparedPrice = (prod.variants[v].compare_at_price);
                                        if (prod.variants[v].compare_at_price == null) {
                                            option_comparedPrice = 0;
                                        }
                                        var option_id = prod.variants[v].id;
                                        if (prod.variants[v].featured_image == null) {
                                            var option_image = prod.images[0];
                                        } else {
                                            var option_image = prod.variants[v].featured_image.src;
                                        }
                                        var option = document.createElement("option");
                                        option.value = option_id;
                                        option.setAttribute("data-image", option_image);
                                        option.setAttribute("data-compare-price", option_comparedPrice);
                                        option.setAttribute("data-price", option_price);
                                        if (prod.variants[v].available == false) {
                                            option.setAttribute("disabled", "disabled");
                                        }
                                        option.innerHTML = option_title;
                                        select.appendChild(option);
                                        if (prod.variants[v].available == true) {
                                            variantsPrice.push(option_price);
                                            variantsImage.push(option_image);
                                        }
                                    }
                                }
                                var span2 = document.createElement("span");
                                span2.className = "n9-quickview-product-price-compare";
                                span2.style = "display: none; font-size: small; margin-left: 10px;";
                                span2.innerHTML = '<s>' + moneyFormat(prod.compare_at_price) + '</s>';
                                div9.appendChild(span2);
                                var span3 = document.createElement("span");
                                span3.className = "n9-quickview-product-price-final";
                                span3.style = "margin-left: 10px;";
                                span3.innerHTML = moneyFormat(prod.price);
                                div9.appendChild(span3);
                                var button1 = document.createElement("button");
                                button1.style = "width: auto !important;display: block;margin: 0 auto;padding-left: 20px;padding-right: 20px;";
                                button1.className = "n9-quickview-btn-custom addly_quickView_addToCart";
                                button1.setAttribute("data-product-id", prod.id);
                                button1.setAttribute("id", "n9_quickview_product_btn_" + prod.id);
                                button1.type = "button";
                                button1.setAttribute("data-text-add-selected", n9_fbt_text_add_to_cart);
                                button1.innerHTML = n9_fbt_text_add_to_cart;
                                div8.appendChild(button1);
                                if (prod.variants.length > 0) {
                                    if (variantsPrice.length > 0) {
                                        span3.innerHTML = moneyFormat(variantsPrice[0]);
                                    }
                                }
                                if (prod.variants.length > 0) {
                                    if (variantsImage.length > 0) {
                                        img1.setAttribute("src", variantsImage[0]);
                                    }
                                }
                                document.querySelector("n9-quickview").appendChild(mainDiv);
                            }
                            document.addEventListener('click', event => {
                                for (var m = 0; m < arrayOfPopups.length; m++) {
                                    var specifiedElement = document.getElementById('N9QuickView_' + arrayOfPopups[m]);
                                    var mainElementShowStatus = document.getElementById('N9QuickViewProduct_' + arrayOfPopups[m]).style.display;
                                    if (mainElementShowStatus != "none") {
                                        if (event.target.contains(specifiedElement) && event.target !== specifiedElement) {
                                            n9_CloseProductQuickView(arrayOfPopups[m]);
                                        }
                                    }
                                }
                            });
                        } 
                    }
                }
            });
        });
    };
    const dataRecommendationsN9 = getRecommendationsN9();

    dataRecommendationsN9.then(() => 
    {
        var N9_atc_btn = document.querySelector("form[action*='/cart/add'] button[type='submit']");
        var ATCbtnClassesOrig = "button button--primary";
        var BtnClassPrimary = "button button--primary";
        var BtnClassSecondary = "button button--secondary";
        if(N9_atc_btn !== null)
        {
            ATCbtnClassesOrig = N9_atc_btn.className;ATCbtnClassesOrig = ATCbtnClassesOrig.replace('width', 'widthh');
            BtnClassPrimary = ATCbtnClassesOrig.replace('secondary', 'primary');
            BtnClassSecondary = ATCbtnClassesOrig.replace('primary', 'secondary');
        }
        document.querySelectorAll('.n9-fbt-btn-custom').forEach((button) => {button.className = button.className + ' ' + BtnClassPrimary;});
        document.querySelectorAll('.n9-fbt-btn-atc').forEach((button) => {button.className = button.className + ' ' + BtnClassPrimary;});
        if(n9_fbt_quickViewOption == 1){ document.querySelectorAll('.n9-quickview-btn-custom').forEach((button) => {button.className = button.className + ' ' + BtnClassPrimary;}); }
    });

    dataRecommendationsN9.then(() => 
    {
        if(upsellLayout == 1)
        {
            class N9_FBT extends HTMLElement 
            {
                moneyFormat(cents, format) 
                {
                    if (typeof cents === 'string') 
                    {
                        cents = cents.replace('.', '');
                    }
                    let value = '';
                    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
                    var formatString = (format || window.money_format);
                    if (!formatString) 
                    {
                        formatString = n9MoneyFormat;
                    }

                    function defaultOption(opt, def) 
                    {
                        return (typeof opt === 'undefined' ? def : opt);
                    }

                    function formatWithDelimiters(number, precision, thousands, decimal) 
                    {
                        precision = defaultOption(precision, 2);
                        thousands = defaultOption(thousands, ',');
                        decimal = defaultOption(decimal, '.');
                        if (Number.isNaN(number) || number == null) {
                            return 0;
                        }
                        number = (number / 100.0).toFixed(precision);
                        const parts = number.split('.');
                        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
                        cents = parts[1] ? (decimal + parts[1]) : '';
                        return dollars + cents;
                    }
                    switch (formatString.match(placeholderRegex)[1]) 
                    {
                        case 'amount':
                            value = formatWithDelimiters(cents, 2);
                            break;
                        case 'amount_no_decimals':
                            value = formatWithDelimiters(cents, 0);
                            break;
                        case 'amount_with_comma_separator':
                            value = formatWithDelimiters(cents, 2, '.', ',');
                            break;
                        case 'amount_no_decimals_with_comma_separator':
                            value = formatWithDelimiters(cents, 0, '.', ',');
                            break;
                    }
                    return formatString.replace(placeholderRegex, value);
                }

                constructor() 
                {
                    super();
                    this.querySelectorAll('.n9-fbt-variant-select').forEach((select) => 
                    {
                        select.addEventListener('change', () => {
                            this.onSelectVariant(select)
                        })
                    });
                    this.querySelectorAll('.n9-fbt-add-checkbox').forEach((checkbox) => 
                    {
                        checkbox.addEventListener('change', () => {
                            this.onCheckVariantChange(checkbox)
                        })
                    });
                    this.querySelector('.n9-fbt-btn-atc').addEventListener('click', this.addSelectedVariantsToCart.bind(this));
                    this.totalPriceChange();
                }
                onSelectVariant(select) 
                {
                    const {image,comparePrice,price} = select.options[select.selectedIndex].dataset;
                    const productItem = select.closest('.n9-fbt-product-item-layout2');
                    const imgEl = productItem.querySelector('.n9-fbt-product-img');
                    const comparePriceEl = productItem.querySelector('.n9-fbt-product-price-compare');
                    const priceEl = productItem.querySelector('.n9-fbt-product-price-final');
                    if (image) 
                    {
                        imgEl.setAttribute('src', image);
                        imgEl.setAttribute('srcset', image);
                    }
                    if (comparePrice) 
                    {
                        if (comparePrice <= price) 
                        {
                            comparePriceEl.style.display = 'none';
                        } 
                        else 
                        {
                            comparePriceEl.style.display = 'inline-block';
                        }
                        comparePriceEl.querySelector('s').innerHTML = this.moneyFormat(comparePrice);
                    } 
                    else 
                    {
                        comparePriceEl.style.display = 'none';
                        comparePriceEl.querySelector('s').innerHTML = '';
                    }
                    priceEl.innerHTML = this.moneyFormat(price);
                    this.totalPriceChange();
                }
                onCheckVariantChange(checkbox) 
                {
                    const productItem = checkbox.closest('.n9-fbt-product-item-layout2');
                    const imgEl = productItem.querySelector('.n9-fbt-product-img');
                    if (checkbox.checked) 
                    {
                        imgEl.style.opacity = '1';
                    } 
                    else 
                    {
                        imgEl.style.opacity = '0.2';
                    }
                    this.totalPriceChange();
                }
                totalPriceChange() 
                {
                    let totalPrice = 0;
                    var allVariants = 0;
                    var totalProds = 0;
                    this.querySelectorAll('.n9-fbt-variant-select').forEach((select) => 
                    {
                        if (select.closest('.n9-fbt-product-item-layout2').querySelector('.n9-fbt-add-checkbox').checked) 
                        {
                            totalPrice += Number(select.options[select.selectedIndex].dataset.price);
                            allVariants++;
                        }
                        totalProds++;
                    });
                    let discountedPrice = 0;
                    let discount = 0;
                    var newTotalPrice = totalPrice / 100.0;
                    if (endDiscountType == 1) 
                    {
                        discountedPrice = newTotalPrice - (endDiscountVal);
                        let shopMoneyFormat = n9MoneyFormat;
                        shopMoneyFormat = shopMoneyFormat;
                        shopMoneyFormat = shopMoneyFormat.charAt(0);
                        var discountInfo = (endDiscountVal);
                        discount = "-" + shopMoneyFormat + discountInfo.toFixed(2);
                    } 
                    else if (endDiscountType == 2) 
                    {
                        discountedPrice = newTotalPrice - (newTotalPrice * endDiscountVal);
                        discount = endDiscountVal;
                        discount = "-" + ((discount * 100).toFixed()) + "%";
                    } 
    
                    if (allVariants > totalProds) 
                    {
                        totalProds = allVariants;
                    }

                    if (totalProds == allVariants) 
                    {
                        if (endDiscountType == 0) 
                        {
                            var offerPriceSoloText = n9_fbt_text_total_price;
                            if(allVariants == 1)
                            {
                                offerPriceSoloText = n9_fbt_text_soloPriceOne;
                            }

                            var message = '<p class="n9-fbt-total-price-line1" style="margin: 0; padding: 0; margin-top: 10px;"><span class="n9-fbt-total-price-text-normal" style="font-size: 16px;">'+offerPriceSoloText+'</span><b class="n9-fbt-total-price-text-price">'+this.moneyFormat(totalPrice)+'</b></p>';
                            this.querySelector('.n9-fbt-total-price-wrapper').innerHTML = message;

                            //this.querySelector('.n9-fbt-total-price').innerHTML = "<b>" + this.moneyFormat(totalPrice) + "</b>";
                            //this.querySelector('#endPriceText').innerHTML = n9_fbt_text_total_price;
                            //this.querySelector('#endPriceText').style.fontSize = "16px";
                        } 
                        else 
                        {
                            var discountOfferPriceText = n9_fbt_text_discounted_price;
                            if(allVariants == 1)
                            {
                                discountOfferPriceText = n9_fbt_text_soloPrice;
                                this.querySelector('.n9-fbt-btn-atc').innerHTML = n9_fbt_text_soloButton;
                                this.querySelector('.n9-fbt-btn-atc').setAttribute("data-text-add-selected", n9_fbt_text_soloButton);
                            }
                            else
                            {
                                this.querySelector('.n9-fbt-btn-atc').innerHTML = n9_fbt_text_add_selected;
                                this.querySelector('.n9-fbt-btn-atc').setAttribute("data-text-add-selected", n9_fbt_text_add_selected);
                            }

                            var message1 = '<p class="n9-fbt-total-price-line1" style="margin: 0; padding: 0; margin-top: 10px; font-size: 14px;"><span class="n9-fbt-total-price-text-normal">'+n9_fbt_text_total_price2+'</span><b class="n9-fbt-total-price-text-price"><s>'+this.moneyFormat(totalPrice)+'</s></b></p>';
                            var message2 = '<p class="n9-fbt-total-price-line2" style="margin: 0; padding: 0;"><span class="n9-fbt-total-price-text-discount">'+discountOfferPriceText+'</span><b class="n9-fbt-total-price-text-price-discounted">'+this.moneyFormat(discountedPrice * 100.0)+'</b><small class="n9-fbt-total-price-text-discountInfo" style="display: initial;margin-left: 5px;">('+discount+')</small></p>';
                            this.querySelector('.n9-fbt-total-price-wrapper').innerHTML = message1 + message2;

                            //this.querySelector('.n9-fbt-total-price').innerHTML = "<s><small style='display: initial;'><b>" + this.moneyFormat(totalPrice) + "</b></small></s> <br>"+n9_fbt_text_discounted_price+"<b>" + this.moneyFormat(discountedPrice * 100.0) + "</b> <small style='display: initial;'>(" + discount + ")</small><br/>";
                            //this.querySelector('#endPriceText').innerHTML = n9_fbt_text_total_price2;
                            //this.querySelector('#endPriceText').style.fontSize = "14px";
                        }
                    } 
                    else 
                    {
                        var message = '<p class="n9-fbt-total-price-line1" style="margin: 0; padding: 0; margin-top: 10px;"><span class="n9-fbt-total-price-text-normal" style="font-size: 16px;">'+n9_fbt_text_total_price+'</span><b class="n9-fbt-total-price-text-price">'+this.moneyFormat(totalPrice)+'</b></p>';
                        this.querySelector('.n9-fbt-total-price-wrapper').innerHTML = message;
                        
                        //this.querySelector('.n9-fbt-total-price').innerHTML = "<b>" + this.moneyFormat(totalPrice) + "</b><br/>";
                        //this.querySelector('#endPriceText').innerHTML = n9_fbt_text_total_price;
                        //this.querySelector('#endPriceText').style.fontSize = "16px";
                    } 
    
                    if (totalPrice === 0) 
                    {
                        this.querySelector('.n9-fbt-btn-atc').disabled = true;
                    } 
                    else 
                    {
                        this.querySelector('.n9-fbt-btn-atc').disabled = false;
                    }
                    //this.querySelector('.n9-fbt-btn-atc').innerHTML = n9_fbt_text_add_selected;
                }
                async addSelectedVariantsToCart() 
                {
                    const btn = this.querySelector('.n9-fbt-btn-atc');
                    btn.innerHTML = `<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>`;
                    btn.style.width = `${btn.clientWidth}px`;
                    var buildUpdate = [];
                    var buildAttribute = [];

                    var allProducts = "";

                    this.querySelectorAll('.n9-fbt-variant-select').forEach((select) => 
                    {
                        if (select.closest('.n9-fbt-product-item-layout2').querySelector('.n9-fbt-add-checkbox').checked) 
                        {
                            var productId = select.getAttribute('data-product-id');
                            buildUpdate.push([Number(select.value), 1]);
                            buildAttribute.push(['n9_upsell--' + productId + '#'+n9CurrentProductId, select.value + ':all'+currentModeAttribute]);
                        }

                        if(endDiscountType > 0)
                        {
                            var currentProductId = select.getAttribute('data-product-id');
                            allProducts = allProducts + currentProductId + ",";
                        }
                    });

                    if(endDiscountType > 0)
                    {
                        allProducts = allProducts.slice(0, -1); // removes last ,

                        //console.log(productsExists(n9_bundle_discounts, allProducts));
                        /*if(!productsExists(n9_bundle_discounts, allProducts))
                        {
                            if(endDiscountType == 1) // fixed
                            {
                                var addObj = {products: allProducts, discountValue: endDiscountVal, discountType: '0'};
                                n9_bundle_discounts.push(addObj);
                            }
                            else if(endDiscountType == 2) // %
                            {
                                var addObj = {products: allProducts, discountValue: endDiscountVal * 100, discountType: '1'};
                                n9_bundle_discounts.push(addObj);
                            }

                            buildAttribute.push(['n9_bundle_discounts', JSON.stringify(n9_bundle_discounts)]);
                        }*/

                        var discountTypeDiscounts = '1';
                        var discountValueDiscounts = endDiscountVal;
                        if(endDiscountType == 1) // fixed
                        {
                            discountTypeDiscounts = '0';
                            discountValueDiscounts = endDiscountVal;
                        }
                        else if(endDiscountType == 2) // %
                        {
                            discountTypeDiscounts = '1';
                            discountValueDiscounts = endDiscountVal * 100;
                        }

                        var addObj = {products: allProducts, discountValue: discountValueDiscounts, discountType: discountTypeDiscounts};
                        addN9BundleDiscountObject(addObj, n9_bundle_discounts);
                        buildAttribute.push(['n9_bundle_discounts', JSON.stringify(n9_bundle_discounts)]);
                    }

                    buildUpdate = arr2obj(buildUpdate);
                    buildAttribute = arr2obj(buildAttribute);

                    var headers = new Headers(
                    {
                        'Content-Type': 'application/json'
                    });
                    var bodyRequest = JSON.stringify(
                    {
                        updates: buildUpdate,
                        attributes: buildAttribute
                    });
                    var request = 
                    {
                        method: 'POST',
                        headers: headers,
                        body: bodyRequest
                    };
                    await fetch('/cart/update.js', request).then(function () {});
                    btn.innerHTML = n9_fbt_text_added;
                    btn.disabled = true;
                    if (n9_upsells_notify) 
                    {
                        if (n9_upsells_mode_bundle == 0) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                        }
                        else if (n9_upsells_mode_bundle == 1) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_bundle, NotifyOptionsUpsells);
                            setTimeout(() => 
                            {
                                location.href = '/cart';
                            }, 2000);
                        } 
                        else if (n9_upsells_mode_bundle == 2) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_bundle, NotifyOptionsUpsells);
                            setTimeout(() => 
                            {
                                location.reload();
                            }, 2000);
                        }
                        else if (n9_upsells_mode_bundle == 3) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_bundle, NotifyOptionsUpsells);
                            setTimeout(() => 
                            {
                                location.href = '/checkout';
                            }, 2000);
                        }
                        else if (n9_upsells_mode_bundle == 4) 
                        {
                            //nothing?
                        }
                        else if (n9_upsells_mode_bundle == 5) 
                        {
                            setTimeout(() => 
                            {
                                location.href = '/cart';
                            }, 1000);
                        }
                        else if (n9_upsells_mode_bundle == 6) 
                        {
                            setTimeout(() => 
                            {
                                location.reload();
                            }, 1000);
                        }
                        else if (n9_upsells_mode_bundle == 7) 
                        {
                            setTimeout(() => 
                            {
                                location.href = '/checkout';
                            }, 1000);
                        }
                    }
                } 
            }

            if(document.querySelector('n9-fbt').hasChildNodes())
            { 
                customElements.define('n9-fbt', N9_FBT); 
            }
        }
        else if(upsellLayout == 2 || upsellLayout == 4 || upsellLayout == 5)
        {
            class N9_FBT extends HTMLElement 
            {
                moneyFormat(cents, format) 
                {
                    if (typeof cents === 'string') 
                    {
                        cents = cents.replace('.', '');
                    }
                    let value = '';
                    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
                    var formatString = (format || window.money_format);
                    if (!formatString) 
                    {
                        formatString = n9MoneyFormat;
                    }

                    function defaultOption(opt, def) 
                    {
                        return (typeof opt === 'undefined' ? def : opt);
                    }

                    function formatWithDelimiters(number, precision, thousands, decimal) 
                    {
                        precision = defaultOption(precision, 2);
                        thousands = defaultOption(thousands, ',');
                        decimal = defaultOption(decimal, '.');
                        if (Number.isNaN(number) || number == null) {
                            return 0;
                        }
                        number = (number / 100.0).toFixed(precision);
                        const parts = number.split('.');
                        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
                        cents = parts[1] ? (decimal + parts[1]) : '';
                        return dollars + cents;
                    }
                    switch (formatString.match(placeholderRegex)[1]) 
                    {
                        case 'amount':
                            value = formatWithDelimiters(cents, 2);
                            break;
                        case 'amount_no_decimals':
                            value = formatWithDelimiters(cents, 0);
                            break;
                        case 'amount_with_comma_separator':
                            value = formatWithDelimiters(cents, 2, '.', ',');
                            break;
                        case 'amount_no_decimals_with_comma_separator':
                            value = formatWithDelimiters(cents, 0, '.', ',');
                            break;
                    }
                    return formatString.replace(placeholderRegex, value);
                }

                constructor() 
                {
                    super();
                    this.querySelectorAll('.n9-fbt-variant-select').forEach((select) => 
                    {
                        select.addEventListener('change', () => 
                        {
                            this.onSelectVariant(select);
                        })
                    });
                    this.querySelectorAll('.n9-fbt-add-checkbox').forEach((checkbox) => 
                    {
                        checkbox.addEventListener('change', () => 
                        {
                            this.onCheckVariantChange(checkbox);
                        })
                    });
                    this.querySelector('.n9-fbt-btn-atc').addEventListener('click', this.addSelectedVariantsToCart.bind(this));
                    this.querySelectorAll('.n9-fbt-btn-custom').forEach((button) => 
                    {
                        button.addEventListener('click', this.addCurrentVariantToCart.bind(this));
                        button.productId = button.getAttribute('data-product-id');
                    });
                    this.totalPriceChange();
                }
                onSelectVariant(select) 
                {
                    const {image,comparePrice,price} = select.options[select.selectedIndex].dataset;
                    const productItem = select.closest('.n9-fbt-product-item-layout3');
                    const imgEl = productItem.querySelector('.n9-fbt-product-img');
                    const comparePriceEl = productItem.querySelector('.n9-fbt-product-price-compare');
                    const priceEl = productItem.querySelector('.n9-fbt-product-price-final');
                    const btnEl = productItem.querySelector('.n9-fbt-btn-custom');
                    if (image) 
                    {
                        imgEl.setAttribute('src', image);
                        imgEl.setAttribute('srcset', image);
                    }
                    if (comparePrice) 
                    {
                        if (comparePrice <= price) 
                        {
                            comparePriceEl.style.display = 'none';
                        } 
                        else 
                        {
                            comparePriceEl.style.display = 'inline-block';
                        }
                        comparePriceEl.querySelector('s').innerHTML = this.moneyFormat(comparePrice);
                    } 
                    else 
                    {
                        comparePriceEl.style.display = 'none';
                        comparePriceEl.querySelector('s').innerHTML = '';
                    }
                    priceEl.innerHTML = this.moneyFormat(price);
                    btnEl.disabled = false;
                    btnEl.innerHTML = n9_fbt_text_add_to_cart;
                    this.querySelector('.n9-fbt-btn-atc').innerHTML = n9_fbt_text_add_selected;
                    this.totalPriceChange();
                }
                onCheckVariantChange(checkbox) 
                {
                    const productItem = checkbox.closest('.n9-fbt-product-item-layout3');
                    const imgEl = productItem.querySelector('.n9-fbt-product-img');
                    if (checkbox.checked) 
                    {
                        imgEl.style.opacity = '1';
                    } 
                    else 
                    {
                        imgEl.style.opacity = '0.2';
                    }
                    this.totalPriceChange();
                }
                totalPriceChange() 
                {
                    let totalPrice = 0;
                    var allVariants = 0;
                    this.querySelectorAll('.n9-fbt-variant-select').forEach((select) => 
                    {
                        if (select.closest('.n9-fbt-product-item-layout3').querySelector('.n9-fbt-add-checkbox').checked) 
                        {
                            totalPrice += Number(select.options[select.selectedIndex].dataset.price);
                            allVariants++;
                        }
                    });
                    let discountedPrice = 0;
                    let discount = 0;
                    var newTotalPrice = totalPrice / 100.0;
                    if (endDiscountType == 1) 
                    {
                        discountedPrice = newTotalPrice - (endDiscountVal);
                        let shopMoneyFormat = n9MoneyFormat;
                        shopMoneyFormat = shopMoneyFormat;
                        shopMoneyFormat = shopMoneyFormat.charAt(0);
                        var discountInfo = (endDiscountVal);
                        discount = "-" + shopMoneyFormat + discountInfo.toFixed(2);
                    } 
                    else if (endDiscountType == 2) 
                    {
                        discountedPrice = newTotalPrice - (newTotalPrice * endDiscountVal);
                        discount = endDiscountVal;
                        discount = "-" + ((discount * 100).toFixed()) + "%";
                    } 

                    if (endDiscountType == 0) 
                    {
                        var offerPriceSoloText = n9_fbt_text_total_price;
                        if(allVariants == 1)
                        {
                            offerPriceSoloText = n9_fbt_text_soloPriceOne;
                        }

                        var message = '<p class="n9-fbt-total-price-line1" style="margin: 0; padding: 0; margin-top: 10px;"><span class="n9-fbt-total-price-text-normal" style="font-size: 16px;">'+offerPriceSoloText+'</span><b class="n9-fbt-total-price-text-price">'+this.moneyFormat(totalPrice)+'</b></p>';
                        this.querySelector('.n9-fbt-total-price-wrapper').innerHTML = message;
                         
                        //this.querySelector('.n9-fbt-total-price').innerHTML = "<b>" + this.moneyFormat(totalPrice) + "</b>";
                        //this.querySelector('#endPriceText').innerHTML = n9_fbt_text_total_price;
                        //this.querySelector('#endPriceText').style.fontSize = "16px";
                    }
                    else 
                    {
                        var discountOfferPriceText = n9_fbt_text_discounted_price;
                        if(allVariants == 1)
                        {
                            discountOfferPriceText = n9_fbt_text_soloPrice;
                            this.querySelector('.n9-fbt-btn-atc').innerHTML = n9_fbt_text_soloButton;
                            this.querySelector('.n9-fbt-btn-atc').setAttribute("data-text-add-selected", n9_fbt_text_soloButton);
                        }
                        else
                        {
                            this.querySelector('.n9-fbt-btn-atc').innerHTML = n9_fbt_text_add_selected;
                            this.querySelector('.n9-fbt-btn-atc').setAttribute("data-text-add-selected", n9_fbt_text_add_selected);
                        }

                        var message1 = '<p class="n9-fbt-total-price-line1" style="margin: 0; padding: 0; margin-top: 10px; font-size: 14px;"><span class="n9-fbt-total-price-text-normal">'+n9_fbt_text_total_price2+'</span><b class="n9-fbt-total-price-text-price"><s>'+this.moneyFormat(totalPrice)+'</s></b></p>';
                        var message2 = '<p class="n9-fbt-total-price-line2" style="margin: 0; padding: 0;"><span class="n9-fbt-total-price-text-discount">'+discountOfferPriceText+'</span><b class="n9-fbt-total-price-text-price-discounted">'+this.moneyFormat(discountedPrice * 100.0)+'</b><small class="n9-fbt-total-price-text-discountInfo" style="display: initial;margin-left: 5px;">('+discount+')</small></p>';
                        this.querySelector('.n9-fbt-total-price-wrapper').innerHTML = message1 + message2;

                        //this.querySelector('.n9-fbt-total-price').innerHTML = "<s><small style='display: initial;'><b>" + this.moneyFormat(totalPrice) + "</b></small></s> <br>"+n9_fbt_text_discounted_price+"<b>" + this.moneyFormat(discountedPrice * 100.0) + "</b> <small style='display: initial;'>(" + discount + ")</small><br/>";
                        //this.querySelector('#endPriceText').innerHTML = n9_fbt_text_total_price2;
                        //this.querySelector('#endPriceText').style.fontSize = "14px";
                    }
                        
                    if (totalPrice === 0) 
                    {
                        this.querySelector('.n9-fbt-btn-atc').disabled = true;
                    } 
                    else 
                    {
                        this.querySelector('.n9-fbt-btn-atc').disabled = false;
                    }
                }
                async addCurrentVariantToCart(evt) 
                {
                    var productId = evt.currentTarget.productId;
                    const btn = this.querySelector('#n9_product_btn_' + productId);
                    btn.innerHTML = `<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>`;
                    var buildUpdate = [];
                    var buildAttribute = [];

                    var allProducts = "";

                    this.querySelectorAll('.n9-fbt-variant-select').forEach((select) => 
                    {
                        if(endDiscountType > 0)
                        {
                            var currentProductId = select.getAttribute('data-product-id');
                            allProducts = allProducts + currentProductId + ",";
                        }
                    });

                    if(endDiscountType > 0)
                    {
                        allProducts = allProducts.slice(0, -1); // removes last ,

                        //console.log(productsExists(n9_bundle_discounts, allProducts));
                        /*if(!productsExists(n9_bundle_discounts, allProducts))
                        {
                            if(endDiscountType == 1) // fixed
                            {
                                var addObj = {products: allProducts, discountValue: endDiscountVal, discountType: '0'};
                                n9_bundle_discounts.push(addObj);
                            }
                            else if(endDiscountType == 2) // %
                            {
                                var addObj = {products: allProducts, discountValue: endDiscountVal * 100, discountType: '1'};
                                n9_bundle_discounts.push(addObj);
                            }

                            buildAttribute.push(['n9_bundle_discounts', JSON.stringify(n9_bundle_discounts)]);
                        }*/
                        var discountTypeDiscounts = '1';
                        var discountValueDiscounts = endDiscountVal;
                        if(endDiscountType == 1) // fixed
                        {
                            discountTypeDiscounts = '0';
                            discountValueDiscounts = endDiscountVal;
                        }
                        else if(endDiscountType == 2) // %
                        {
                            discountTypeDiscounts = '1';
                            discountValueDiscounts = endDiscountVal * 100;
                        }

                        var addObj = {products: allProducts, discountValue: discountValueDiscounts, discountType: discountTypeDiscounts};
                        addN9BundleDiscountObject(addObj, n9_bundle_discounts);
                        buildAttribute.push(['n9_bundle_discounts', JSON.stringify(n9_bundle_discounts)]);
                    }

                    this.querySelectorAll('#n9_variant_select_' + productId).forEach((select) => 
                    {
                        buildUpdate.push([Number(select.value), 1]);
                        buildAttribute.push(['n9_upsell--' + productId + '#'+n9CurrentProductId, select.value + ':btn'+currentModeAttribute]);
                    });

                    buildUpdate = arr2obj(buildUpdate);
                    buildAttribute = arr2obj(buildAttribute);
                    var headers = new Headers(
                    {
                        'Content-Type': 'application/json'
                    });
                    var bodyRequest = JSON.stringify(
                    {
                        updates: buildUpdate,
                        attributes: buildAttribute
                    });
                    var request = 
                    {
                        method: 'POST',
                        headers: headers,
                        body: bodyRequest
                    };
                    await fetch('/cart/update.js', request).then(function () {});
                    btn.innerHTML = n9_fbt_text_added;
                    btn.disabled = true;
                    
                    if (n9_upsells_notify)
                    {
                        if (n9_upsells_mode_single == 0) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                        } 
                        else if (n9_upsells_mode_single == 1) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                            setTimeout(() => 
                            {
                                location.href = '/cart';
                            }, 2000);
                        } 
                        else if (n9_upsells_mode_single == 2) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                            setTimeout(() => 
                            {
                                location.reload();
                            }, 2000);
                        }
                        else if (n9_upsells_mode_single == 3) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                            setTimeout(() => 
                            {
                                location.href = '/checkout';
                            }, 2000);
                        } 
                        else if (n9_upsells_mode_single == 4) 
                        {
                            //nothing for now
                        }
                        else if (n9_upsells_mode_single == 5) 
                        {
                            setTimeout(() => 
                            {
                                location.href = '/cart';
                            }, 1000);
                        }
                        else if (n9_upsells_mode_single == 6) 
                        {
                            setTimeout(() => 
                            {
                                location.reload();
                            }, 1000);
                        }
                        else if (n9_upsells_mode_single == 7) 
                        {
                            setTimeout(() => 
                            {
                                location.href = '/checkout';
                            }, 1000);
                        }
                    }
                }
                async addSelectedVariantsToCart() 
                {
                    const btn = this.querySelector('.n9-fbt-btn-atc');
                    btn.innerHTML = `<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>`;
                    btn.style.width = `${btn.clientWidth}px`;
                    var buildUpdate = [];
                    var buildAttribute = [];

                    var allProducts = "";

                    this.querySelectorAll('.n9-fbt-variant-select').forEach((select) => 
                    {
                        if (select.closest('.n9-fbt-product-item-layout3').querySelector('.n9-fbt-add-checkbox').checked) 
                        {
                            var productId = select.getAttribute('data-product-id');
                            buildUpdate.push([Number(select.value), 1]);
                            buildAttribute.push(['n9_upsell--' + productId + '#'+n9CurrentProductId, select.value + ':all'+currentModeAttribute]);
                        }

                        if(endDiscountType > 0)
                        {
                            var currentProductId = select.getAttribute('data-product-id');
                            allProducts = allProducts + currentProductId + ",";
                        }
                    });

                    if(endDiscountType > 0)
                    {
                        allProducts = allProducts.slice(0, -1); // removes last ,

                        //console.log(productsExists(n9_bundle_discounts, allProducts));
                        /*if(!productsExists(n9_bundle_discounts, allProducts))
                        {
                            if(endDiscountType == 1) // fixed
                            {
                                var addObj = {products: allProducts, discountValue: endDiscountVal, discountType: '0'};
                                n9_bundle_discounts.push(addObj);
                            }
                            else if(endDiscountType == 2) // %
                            {
                                var addObj = {products: allProducts, discountValue: endDiscountVal * 100, discountType: '1'};
                                n9_bundle_discounts.push(addObj);
                            }

                            buildAttribute.push(['n9_bundle_discounts', JSON.stringify(n9_bundle_discounts)]);
                        }*/
                        var discountTypeDiscounts = '1';
                        var discountValueDiscounts = endDiscountVal;
                        if(endDiscountType == 1) // fixed
                        {
                            discountTypeDiscounts = '0';
                            discountValueDiscounts = endDiscountVal;
                        }
                        else if(endDiscountType == 2) // %
                        {
                            discountTypeDiscounts = '1';
                            discountValueDiscounts = endDiscountVal * 100;
                        }

                        var addObj = {products: allProducts, discountValue: discountValueDiscounts, discountType: discountTypeDiscounts};
                        addN9BundleDiscountObject(addObj, n9_bundle_discounts);
                        buildAttribute.push(['n9_bundle_discounts', JSON.stringify(n9_bundle_discounts)]);
                    }

                    buildUpdate = arr2obj(buildUpdate);
                    buildAttribute = arr2obj(buildAttribute);
                    var headers = new Headers(
                    {
                        'Content-Type': 'application/json'
                    });
                    var bodyRequest = JSON.stringify(
                    {
                        updates: buildUpdate,
                        attributes: buildAttribute
                    });
                    var request = 
                    {
                        method: 'POST',
                        headers: headers,
                        body: bodyRequest
                    };
                    await fetch('/cart/update.js', request).then(function () {});
                    btn.innerHTML = n9_fbt_text_added;
                    btn.disabled = true;
                    if (n9_upsells_notify) 
                    {
                        if (n9_upsells_mode_bundle == 0) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                        }
                        else if (n9_upsells_mode_bundle == 1) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_bundle, NotifyOptionsUpsells);
                            setTimeout(() => 
                            {
                                location.href = '/cart';
                            }, 2000);
                        } 
                        else if (n9_upsells_mode_bundle == 2) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_bundle, NotifyOptionsUpsells);
                            setTimeout(() => 
                            {
                                location.reload();
                            }, 2000);
                        }
                        else if (n9_upsells_mode_bundle == 3) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_bundle, NotifyOptionsUpsells);
                            setTimeout(() => 
                            {
                                location.href = '/checkout';
                            }, 2000);
                        } 
                        else if (n9_upsells_mode_bundle == 4) 
                        {
                            //nothing for now
                        }
                        else if (n9_upsells_mode_bundle == 5) 
                        {
                            setTimeout(() => 
                            {
                                location.href = '/cart';
                            }, 1000);
                        }
                        else if (n9_upsells_mode_bundle == 6) 
                        {
                            setTimeout(() => 
                            {
                                location.reload();
                            }, 1000);
                        }
                        else if (n9_upsells_mode_bundle == 7) 
                        {
                            setTimeout(() => 
                            {
                                location.href = '/checkout';
                            }, 1000);
                        }
                    }
                }
            }

            if(document.querySelector('n9-fbt').hasChildNodes())
            { 
                customElements.define('n9-fbt', N9_FBT); 
            }
        }
        else if(upsellLayout == 3 || upsellLayout == 6)
        {
            class N9_FBT extends HTMLElement 
            {
                moneyFormat(cents, format) 
                {
                    if (typeof cents === 'string') 
                    {
                        cents = cents.replace('.', '');
                    }
                    let value = '';
                    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
                    var formatString = (format || window.money_format);
                    if (!formatString) 
                    {
                        formatString = n9MoneyFormat;
                    }

                    function defaultOption(opt, def) 
                    {
                        return (typeof opt === 'undefined' ? def : opt);
                    }

                    function formatWithDelimiters(number, precision, thousands, decimal) 
                    {
                        precision = defaultOption(precision, 2);
                        thousands = defaultOption(thousands, ',');
                        decimal = defaultOption(decimal, '.');
                        if (Number.isNaN(number) || number == null) {
                            return 0;
                        }
                        number = (number / 100.0).toFixed(precision);
                        const parts = number.split('.');
                        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
                        cents = parts[1] ? (decimal + parts[1]) : '';
                        return dollars + cents;
                    }
                    switch (formatString.match(placeholderRegex)[1]) 
                    {
                        case 'amount':
                            value = formatWithDelimiters(cents, 2);
                            break;
                        case 'amount_no_decimals':
                            value = formatWithDelimiters(cents, 0);
                            break;
                        case 'amount_with_comma_separator':
                            value = formatWithDelimiters(cents, 2, '.', ',');
                            break;
                        case 'amount_no_decimals_with_comma_separator':
                            value = formatWithDelimiters(cents, 0, '.', ',');
                            break;
                    }
                    return formatString.replace(placeholderRegex, value);
                }

                constructor() 
                {
                    super();
                    this.querySelectorAll('.n9-fbt-variant-select').forEach((select) => 
                    {
                        select.addEventListener('change', () => 
                        {
                            this.onSelectVariant(select);
                        })
                    });
                    this.querySelectorAll('.n9-fbt-btn-custom').forEach((button) => 
                    {
                        button.addEventListener('click', this.addCurrentVariantToCart.bind(this));
                        button.productId = button.getAttribute('data-product-id');
                    });
                }
                onSelectVariant(select) 
                {
                    const {image,comparePrice,price} = select.options[select.selectedIndex].dataset;
                    const productItem = select.closest('.n9-fbt-product-item-layout4');
                    const imgEl = productItem.querySelector('.n9-fbt-product-img');
                    const btnEl = productItem.querySelector('.n9-fbt-btn-custom');
                    const priceEl = productItem.querySelector('.n9-fbt-product-price-final');
                    const comparePriceDiv = productItem.querySelector('.n9-fbt-product-price');
                    const comparePriceEl = comparePriceDiv.querySelector('.n9-fbt-product-price-compare');
                    if (image) 
                    {
                        imgEl.setAttribute('src', image);
                        imgEl.setAttribute('srcset', image);
                    }
                    if (comparePrice) 
                    {
                        if (comparePrice <= price) 
                        {
                            comparePriceEl.style.display = 'none';
                        } 
                        else 
                        {
                            comparePriceEl.style.display = 'inline-block';
                        }
                        comparePriceEl.querySelector('s').innerHTML = this.moneyFormat(comparePrice);
                    } 
                    else 
                    {
                        comparePriceEl.style.display = 'none';
                        comparePriceEl.querySelector('s').innerHTML = '';
                    }
                    priceEl.innerHTML = this.moneyFormat(price);
                    btnEl.disabled = false;
                    btnEl.innerHTML = n9_fbt_text_add_to_cart;
                }
                async addCurrentVariantToCart(evt) 
                {
                    var productId = evt.currentTarget.productId;
                    const btn = this.querySelector('#n9_product_btn_' + productId);
                    btn.innerHTML = `<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>`;
                    var buildUpdate = [];
                    var buildAttribute = [];
                    this.querySelectorAll('#n9_variant_select_' + productId).forEach((select) => 
                    {
                        buildUpdate.push([Number(select.value), 1]);
                        buildAttribute.push(['n9_upsell--' + productId + '#'+productId, select.value + ':btn'+currentModeAttribute]);
                    });
                    buildUpdate = arr2obj(buildUpdate);
                    buildAttribute = arr2obj(buildAttribute);
                    var headers = new Headers(
                    {
                        'Content-Type': 'application/json'
                    });
                    var bodyRequest = JSON.stringify(
                    {
                        updates: buildUpdate,
                        attributes: buildAttribute
                    });
                    var request = 
                    {
                        method: 'POST',
                        headers: headers,
                        body: bodyRequest
                    };
                    await fetch('/cart/update.js', request).then(function () {});
                    btn.innerHTML = n9_fbt_text_added;
                    btn.disabled = true;
                    if (n9_upsells_notify) 
                    {
                        if (n9_upsells_mode_single == 0) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                        }
                        else if (n9_upsells_mode_single == 1) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                            setTimeout(() => 
                            {
                                location.href = '/cart';
                            }, 2000);
                        } 
                        else if (n9_upsells_mode_single == 2) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                            setTimeout(() => 
                            {
                                location.reload();
                            }, 2000);
                        }
                        else if (n9_upsells_mode_single == 3) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                            setTimeout(() => 
                            {
                                location.href = '/checkout';
                            }, 2000);
                        } 
                        else if (n9_upsells_mode_single == 4) 
                        {
                            //nothing for now
                        }
                        else if (n9_upsells_mode_single == 5) 
                        {
                            setTimeout(() => 
                            {
                                location.href = '/cart';
                            }, 1000);
                        }
                        else if (n9_upsells_mode_single == 6) 
                        {
                            setTimeout(() => 
                            {
                                location.reload();
                            }, 1000);
                        }
                        else if (n9_upsells_mode_single == 7) 
                        {
                            setTimeout(() => 
                            {
                                location.href = '/checkout';
                            }, 1000);
                        }
                    }
                }
            }

            if(document.querySelector('n9-fbt').hasChildNodes())
            { 
                customElements.define('n9-fbt', N9_FBT); 

                setTimeout(() => 
                {
                    if(upsellLayout == 6) Splide.defaults = {type: 'loop',perPage: 2,perMove: 2,pagination: true,flickMaxPages: 1,autoplay: true,pauseOnHover: true,pauseOnFocus: true,arrows: false,clones: 0, focus: 0, omitEnd : true};
                    else Splide.defaults = {type: 'loop',perPage: 1,pagination: true,flickMaxPages: 1,autoplay: true,pauseOnHover: true,pauseOnFocus: true,arrows: false,clones: 0};
                    var splide = new Splide('.splide');splide.mount();
                }, 1000);
            }
        }

        
    });

    if(n9_fbt_quickViewOption == 1)
    {
        dataRecommendationsN9.then(() => 
        {
            class N9_QuickView extends HTMLElement 
            {
                constructor() 
                {
                    super();
                    this.querySelectorAll('.n9-quickview-variant-select').forEach((select) => 
                    {
                        select.addEventListener('change', () => 
                        {
                            this.onSelectVariant(select);
                        })
                    });
                    this.querySelectorAll('.n9-quickview-btn-custom').forEach((button) => 
                    {
                        button.addEventListener('click', this.addCurrentVariantToCart.bind(this));
                        button.productId = button.getAttribute('data-product-id');
                    });
                }
                onSelectVariant(select) 
                {
                    const {image,comparePrice,price} = select.options[select.selectedIndex].dataset;
                    var select_product = select.getAttribute('data-product-id');
                    const footerBox = select.closest('.n9Upsells-Product-FooterBox');
                    const productBlock = document.querySelector("#n9-quickview-product-block_" + select_product);
                    const imgEl = productBlock.firstElementChild;
                    const btnEl = footerBox.querySelector('.n9-quickview-btn-custom');
                    const comparePriceEl = footerBox.querySelector('.n9-quickview-product-price-compare');
                    const priceEl = footerBox.querySelector('.n9-quickview-product-price-final');
                    if (image) 
                    {
                        imgEl.setAttribute('src', image);
                        imgEl.setAttribute('srcset', image);
                    }
                    if (comparePrice) 
                    {
                        if (comparePrice <= price) 
                        {
                            comparePriceEl.style.display = 'none';
                        } 
                        else 
                        {
                            comparePriceEl.style.display = 'inline-block';
                        }
                        comparePriceEl.querySelector('s').innerHTML = this.moneyFormat(comparePrice);
                    } 
                    else 
                    {
                        comparePriceEl.style.display = 'none';
                        comparePriceEl.querySelector('s').innerHTML = '';
                    }
                    priceEl.innerHTML = this.moneyFormat(price);
                    btnEl.disabled = false;
                    btnEl.innerHTML = n9_fbt_text_add_to_cart;
                }
                async addCurrentVariantToCart(evt) 
                {
                    var productId = evt.currentTarget.productId;
                    const btn = this.querySelector('#n9_quickview_product_btn_' + productId);
                    btn.innerHTML = `<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>`;
                    var buildUpdate = [];
                    var buildAttribute = [];
                    this.querySelectorAll('#n9_quickview_variant_select_' + productId).forEach((select) => {
                        buildUpdate.push([Number(select.value), 1]);
                        buildAttribute.push(['n9_upsell--' + productId + '#'+n9CurrentProductId, select.value + ':quickview'+currentModeAttribute]);
                    });
                    buildUpdate = arr2obj(buildUpdate);
                    buildAttribute = arr2obj(buildAttribute);
                    var headers = new Headers({
                        'Content-Type': 'application/json'
                    });
                    var bodyRequest = JSON.stringify({
                        updates: buildUpdate,
                        attributes: buildAttribute
                    });
                    var request = {
                        method: 'POST',
                        headers: headers,
                        body: bodyRequest
                    };
                    await fetch('/cart/update.js', request).then(function () {});
                    btn.innerHTML = n9_fbt_text_added;
                    btn.disabled = true;
                    if (n9_upsells_notify) 
                    {
                        if (n9_upsells_mode_single == 0) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                        }
                        else if (n9_upsells_mode_single == 1) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                            setTimeout(() => 
                            {
                                location.href = '/cart';
                            }, 2000);
                        } 
                        else if (n9_upsells_mode_single == 2) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                            setTimeout(() => 
                            {
                                location.reload();
                            }, 2000);
                        }
                        else if (n9_upsells_mode_single == 3) 
                        {
                            Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                            setTimeout(() => 
                            {
                                location.href = '/checkout';
                            }, 2000);
                        } 
                        else if (n9_upsells_mode_single == 4) 
                        {
                            //nothing for now
                        }
                        else if (n9_upsells_mode_single == 5) 
                        {
                            setTimeout(() => 
                            {
                                location.href = '/cart';
                            }, 1000);
                        }
                        else if (n9_upsells_mode_single == 6) 
                        {
                            setTimeout(() => 
                            {
                                location.reload();
                            }, 1000);
                        }
                        else if (n9_upsells_mode_single == 7) 
                        {
                            setTimeout(() => 
                            {
                                location.href = '/checkout';
                            }, 1000);
                        }
                    }
                }
                moneyFormat(cents, format) 
                {
                    if (typeof cents === 'string') 
                    {
                        cents = cents.replace('.', '');
                    }
                    let value = '';
                    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
                    var formatString = (format || window.money_format);
                    if (!formatString) {
                        formatString = n9MoneyFormat;
                    }

                    function defaultOption(opt, def) {
                        return (typeof opt === 'undefined' ? def : opt);
                    }

                    function formatWithDelimiters(number, precision, thousands, decimal) {
                        precision = defaultOption(precision, 2);
                        thousands = defaultOption(thousands, ',');
                        decimal = defaultOption(decimal, '.');
                        if (Number.isNaN(number) || number == null) {
                            return 0;
                        }
                        number = (number / 100.0).toFixed(precision);
                        const parts = number.split('.');
                        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
                        cents = parts[1] ? (decimal + parts[1]) : '';
                        return dollars + cents;
                    }
                    switch (formatString.match(placeholderRegex)[1]) {
                        case 'amount':
                            value = formatWithDelimiters(cents, 2);
                            break;
                        case 'amount_no_decimals':
                            value = formatWithDelimiters(cents, 0);
                            break;
                        case 'amount_with_comma_separator':
                            value = formatWithDelimiters(cents, 2, '.', ',');
                            break;
                        case 'amount_no_decimals_with_comma_separator':
                            value = formatWithDelimiters(cents, 0, '.', ',');
                            break;
                    }
                    return formatString.replace(placeholderRegex, value);
                }
            }
            customElements.define('n9-quickview', N9_QuickView);
            document.body.insertAdjacentElement("afterbegin", document.querySelector("n9-quickview")); 

        }); 
    }
}

function arr2obj(arr) {let obj = {};arr.forEach((v) => {let key = v[0];let value = v[1];obj[key] = value;});return obj;}

function n9_OpenProductQuickView(id, handle) 
{
    if(n9_fbt_quickViewOption == 1)
    {
        if(document.querySelector('#N9QuickViewProduct_' + id) !== null)
        {
            document.querySelector('#N9QuickViewProduct_' + id).style.display = '';
            setTimeout(() => 
            {
                document.querySelector('#N9QuickViewProduct_' + id).style.opacity = '1';
                document.querySelector('#N9QuickViewProduct_' + id + '_2').style.display = '';
            }, 100);
        }
    }
    else if(n9_fbt_quickViewOption == 2)
    {
        window.open('/products/'+handle, '_blank').focus();
    }
}

function n9_CloseProductQuickView(id) 
{
    document.querySelector('#N9QuickViewProduct_' + id + '_2').classList.add('n9-animation-zoom-out');
    setTimeout(() => 
    {
        document.querySelector('#N9QuickViewProduct_' + id).style.opacity = '0';
    }, 200);
    setTimeout(() => 
    {
        document.querySelector('#N9QuickViewProduct_' + id + '_2').style.display = 'none';
        document.querySelector('#N9QuickViewProduct_' + id + '_2').classList.remove('n9-animation-zoom-out');
    }, 500);
    setTimeout(() => 
    {
        document.querySelector('#N9QuickViewProduct_' + id).style.display = 'none';
    }, 700);
} 